//
// locales/vanilla/sr-Latn.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/sr-Latn.json';
import localeData from 'react-intl/locale-data/sr.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
